<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs/util/url'
  const task = {
      1: window.$t('crs.active.task1'),
      3: window.$t('crs.active.task3'),
      4: window.$t('crs.active.task4'),
      5: window.$t('crs.active.task5'),
      6: window.$t('crs.active.task6'),
      7: window.$t('crs.active.task7'),
      8: window.$t('crs.active.task8'),
      9: window.$t('crs.active.task9'),
      10: window.$t('crs.active.task10'),
  };
  const customerStatus = {
      A:"已激活",
      S:"冻结",
      D:"销户",
      BL:"黑名单",
      N:"未激活"
  };
  export default {
    name: 'activeuserbonus',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs.bt.search') == clickName) {
            this.queryData = data;
            this.$refs.childTable.defaultGetData(data);
        }
        if("导出" == clickName || window.$t('crs.bt.export') == clickName){
            var exportURL = Url.active.bonus.export
            var qs = require('qs');
            this.$axios.post(exportURL, qs.stringify(data),{responseType:'blob'
            }).then(function (response) {
              const url = URL.createObjectURL(new Blob([response], {type: 'application/vnd.ms-excel'}))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', '奖品发放记录')
              document.body.appendChild(link)
              link.click()
            }).catch(function (error) {
              console.log(error);
            });
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs.active.activeName'), field: 'activeName'},
              { title: window.$t('crs.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs.common.phone'), field: 'phone'},
              { title: window.$t('crs.active.task'), field: 'task',type:2,optionList:task},
              { title: window.$t('crs.common.status'), field: 'customerStatus',type:2,optionList:customerStatus},
              { title: window.$t('crs.common.startTime'), type:5, field: 'startTime'},
              { title: window.$t('crs.common.endTime'), type:5, field: 'endTime'},
              { title: window.$t('crs.active.customerCreateStartTime'), type:5, field: 'customerCreateStartTime'},
              { title: window.$t('crs.active.customerCreateEndTime'), type:5, field: 'customerCreateEndTime'},
              { title: window.$t('crs.active.customerActivatedStartTime'), type:5, field: 'customerActivatedStartTime'},
              { title: window.$t('crs.active.customerActivatedEndTime'), type:5, field: 'customerActivatedEndTime'},
              {click: window.$t('crs.bt.search')},
              {click: window.$t('crs.bt.export')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.bonus.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('crs.active.orderNo'), field: 'orderNo'},
              { title: window.$t('crs.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs.active.activeName'), field: 'activeName'},
              { title: window.$t('crs.common.startTime'), field: 'startTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.common.endTime'), field: 'endTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.chineseName'), field: 'chineseName'},
              { title: window.$t('crs.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs.common.phone'), field: 'phone'},
              { title: window.$t('crs.active.taskName'), field: 'taskName'},
              { title: window.$t('crs.active.amountCny'), field: 'amountCny'},
              { title: window.$t('crs.active.amount'), field: 'amount'},
              { title: window.$t('crs.active.platform'), field: 'platform'},
              { title: window.$t('crs.active.customerCreateTime'), field: 'customerCreateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.customerActivatedTime'), field: 'customerActivatedTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.common.status'), field: 'customerStatus'},
              { title: window.$t('crs.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
          ]
        }
      }
    }
  }
</script>
